import React, { createContext, useContext, useState, useCallback } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("mc_lang") || "it");

  const changeLang = useCallback((l) => {
    setLang(l);
    localStorage.setItem("mc_lang", l);
  }, []);

  const toggle = useCallback(() => {
    changeLang(lang === "it" ? "en" : "it");
  }, [lang, changeLang]);

  const t = translations[lang];

  return (
    <LanguageContext.Provider value={{ lang, setLang: changeLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
